/**
 * Freedom Shop New In Section JavaScript
 * Handles Swiper initialization for product cards
 */

(function() {
  'use strict';

  let swiperInstances = [];

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when section reloads (Theme Editor)
  document.addEventListener('shopify:section:load', function(event) {
    const section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (section && section.classList.contains('freedom-shop-new-in')) {
      destroySwipers();
      waitForSwiper(function() {
        initSwipers();
      });
    }
  });

  // Also listen for AJAX content updates
  const observer = new MutationObserver(function(mutations) {
    const shopNewIn = document.querySelector('.freedom-shop-new-in');
    if (shopNewIn) {
      const swiperContainers = shopNewIn.querySelectorAll('[data-card-swiper]:not([data-initialized])');
      if (swiperContainers.length > 0) {
        initSwipers();
      }
    }
  });

  function waitForSwiper(callback, maxAttempts) {
    maxAttempts = maxAttempts || 50; // 5 seconds max wait
    let attempts = 0;

    function check() {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(check, 100);
      }
    }

    check();
  }

  function init() {
    // Wait for Swiper library to load
    waitForSwiper(function() {
      initSwipers();

      // Start observing for dynamic content
      const shopNewIn = document.querySelector('.freedom-shop-new-in');
      if (shopNewIn) {
        observer.observe(shopNewIn, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  function initSwipers() {
    if (typeof Swiper === 'undefined') {
      return;
    }

    const swiperContainers = document.querySelectorAll('.freedom-shop-new-in [data-card-swiper]:not([data-initialized])');
    
    swiperContainers.forEach(function(container) {
      // Check if product has 2+ images
      const slides = container.querySelectorAll('.swiper-slide');
      if (slides.length < 2) {
        return; // Skip initialization if less than 2 images
      }

      // Find scrollbar element (sibling to swiper container)
      const productCard = container.closest('.freedom-product-card');
      if (!productCard) return;
      
      const scrollbarWrap = productCard.querySelector('.freedom-scrollbar-wrap');
      if (!scrollbarWrap) return;
      
      const scrollbarEl = scrollbarWrap.querySelector('.swiper-scrollbar');
      if (!scrollbarEl) return;

      // Mark as initialized to prevent double initialization
      container.setAttribute('data-initialized', 'true');

      // Initialize Swiper
      const swiper = new Swiper(container, {
        slidesPerView: 1,
        loop: false,
        speed: 250,
        allowTouchMove: true,
        navigation: false,
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false
        }
      });

      // Update Swiper after initialization to ensure correct measurements
      requestAnimationFrame(function() {
        swiper.update();
      });

      // Wait for images to load, then update again
      const images = container.querySelectorAll('img');
      let loadedCount = 0;
      const totalImages = images.length;

      if (totalImages > 0) {
        images.forEach(function(img) {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === totalImages) {
              requestAnimationFrame(function() {
                swiper.update();
              });
            }
          } else {
            img.addEventListener('load', function() {
              loadedCount++;
              if (loadedCount === totalImages) {
                requestAnimationFrame(function() {
                  swiper.update();
                });
              }
            });
            img.addEventListener('error', function() {
              loadedCount++;
              if (loadedCount === totalImages) {
                requestAnimationFrame(function() {
                  swiper.update();
                });
              }
            });
          }
        });
      } else {
        // No images, just update once
        requestAnimationFrame(function() {
          swiper.update();
        });
      }

      // Store instance for cleanup
      swiperInstances.push(swiper);
    });
  }

  function destroySwipers() {
    swiperInstances.forEach(function(swiper) {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });
    swiperInstances = [];

    // Remove initialization markers
    const initializedContainers = document.querySelectorAll('.freedom-shop-new-in [data-card-swiper][data-initialized]');
    initializedContainers.forEach(function(container) {
      container.removeAttribute('data-initialized');
    });
  }
})();

